export const DislikeSecond = ({ width = '13', height = '13' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3 0.149999H1.95V8.6H1.3C0.955219 8.6 0.624558 8.46304 0.380761 8.21924C0.136964 7.97544 0 7.64478 0 7.3V1.45C0 1.10522 0.136964 0.774558 0.380761 0.530761C0.624558 0.286963 0.955219 0.149999 1.3 0.149999ZM11.7 8.6H7.15L7.8793 10.7892C7.94437 10.9846 7.9621 11.1926 7.93102 11.3962C7.89994 11.5998 7.82094 11.7931 7.70053 11.9601C7.58013 12.1272 7.42175 12.2632 7.23845 12.3571C7.05516 12.451 6.85218 12.4999 6.64625 12.5H6.5L3.25 8.9653V0.149999H10.4L12.9428 5.7374L13 6V7.3C13 7.64478 12.863 7.97544 12.6192 8.21924C12.3754 8.46304 12.0448 8.6 11.7 8.6V8.6Z"
        fill="#FFAB09"
      />
    </svg>
  );
};
